
angular.module('bmsApp.directives').controller('ComplaintNoteFormCtrl', [
	'$scope',
	'$log',
	'$timeout',
	'$q',
	'$modalInstance',
	'$ngBootbox',
	'ComplaintNoteSvc',
	'complaintNote',
	'$window', function (
		$scope,
		$log,
		$timeout,
		$q,
		$modalInstance,
		$ngBootbox,
		ComplaintNoteSvc,
		complaintNote,
		$window) {

	$scope.complaintNote = complaintNote;

	$scope.cancel = function () {
		$ngBootbox.confirm('Are you sure you want to do this?')
			.then(function () {
				$modalInstance.dismiss('cancel');
			});
	};

	$scope.init = function () {
		console.log(complaintNote);
		$scope.processing = false;
		$scope.enableSubmit = true;
	};

	$scope.submit = function () {
		$scope.processing = true;

		var modalResult = {
			success: false
		};

		console.log($scope.complaintNote);

		var savePromise = $scope.complaintNote.id ? ComplaintNoteSvc.update($scope.complaintNote) : ComplaintNoteSvc.create($scope.complaintNote);
		savePromise
			.then(function (response) {
				modalResult.success = response.data.success;
				modalResult.action = $scope.complaintNote.id ? 'update' : 'create';
				$modalInstance.close(modalResult);
			}, function (error) {
				modalResult.error = error;
				$scope.errors = error;
			})
			.finally(function () {
				$scope.processing = false;
			});
	};

	$scope.formvalidatorconfig = {
		submitHandler: function (form) {
			$scope.submit();
		},
		errorPlacement: function (error, element) {
			error.appendTo('#complaint-note-errors');
		},
		errorContainer: '#complaint-note-errors'
	};

}]);
